import axios from "axios";
import { getToken } from "./token";

// Use VITE_ prefix for environment variables
const baseURL =
  import.meta.env.VITE_PUBLIC_API_URL || "https://api.codoo.net/api/";

const instance = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
  },
});

// Request Interceptor: Injects token into every call
instance.interceptors.request.use((config) => {
  const token = getToken();

  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Handle Locale/Language
  if (!config.params) config.params = {};
  config.params.lang = localStorage.getItem("locale") || "en";

  return config;
});

// Response Interceptor: Handles expired sessions (401)
instance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      // Optional: Clear token or redirect to login
      // deleteToken();
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const apiClient = () => instance;
